const FullScreenSpinner = (props) => {
  return (
    <div className="fullSpinner">
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </div>
  );
};

export default FullScreenSpinner;
